import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {EmpresaService} from "../../../services/empresa.service";
import {ItemPlano} from "../../../models/lista-plano";
import {NovaEmpresa} from "../../../models/nova-empresa";
import {NovoUsuario} from "../../../../auth/models/novo-usuario";
import {ActivatedRoute, Router} from "@angular/router";
import {PlanoService} from "../../../services/plano.service";

@Component({
    selector: 'app-cadastrar',
    templateUrl: './cadastrar.component.html',
    styleUrl: './cadastrar.component.css',
    standalone: false
})
export class CadastrarComponent {
  guid = '';

  constructor(private route: ActivatedRoute) {
    this.guid = this.route.snapshot.params['guid'];
  }
}
